(() => {
  const tag = 'rubik-combined-listings';
  const tracked = new WeakSet();
  const css = `
    .rcl__swatch-media { position: relative; }
    .rcl__swatch-image {
      position: absolute;
      inset: 0;
      width: 100%;
      height: 100%;
      object-fit: var(--rcl-swatch-image-fit, contain);
      object-position: center;
      margin: 0;
    }
  `;
  function attach(host, attempt = 0) {
    if (!host.isConnected || tracked.has(host)) return;
    const root = host.shadowRoot;
    if (!root) {
      if (attempt < 20) setTimeout(() => attach(host, attempt + 1), 100);
      return;
    }
    tracked.add(host);
    const style = document.createElement('style');
    style.dataset.bkRubikCenter = '';
    style.textContent = css;
    const ensureStyle = () => {
      if (style.parentNode !== root) root.append(style);
    };
    ensureStyle();
    new MutationObserver(ensureStyle).observe(root, { childList: true });
  }
  customElements.whenDefined(tag).then(() => {
    for (const host of document.querySelectorAll(tag)) attach(host);
    new MutationObserver(records => {
      for (const record of records) for (const node of record.addedNodes) {
        if (!(node instanceof Element)) continue;
        if (node.matches(tag)) attach(node);
        for (const host of node.querySelectorAll(tag)) attach(host);
      }
    }).observe(document.body, { childList: true, subtree: true });
  });
})();
